import React from "react";
import {GlobalAccordionStyled} from "./styled/GlobalAccordionStyled";
import {GlobalStyled} from "./styled/GlobalStyled";
import {GlobalModalStyled} from "./styled/GlobalModalStyled";
import {GlobalOverlaysStyled} from "./styled/GlobalOverlaysStyled";
import {GlobalAlertsStyled} from "./styled/GlobalAlertsStyled";
import {GlobalFormsStyled} from "./styled/GlobalFormsStyled";
import {GlobalDatePickerStyled} from "./styled/GlobalDatePickerStyled";
import {GlobalNotificationsStyled} from "./styled/GlobalNotificationsStyled";
import {GlobalUtilsStyled} from "./styled/GlobalUtilsStyled";
import { GlobalButtonsStyled } from "./styled/GlobalButtonsStyled";
import { GlobalListStyled } from "./styled/GlobalListStyled";
import { useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../Location/locationSelectors';

export const GlobalStyles = () => {
    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);

    return <>
        <GlobalStyled/>
        <GlobalAccordionStyled/>
        <GlobalAlertsStyled/>
        <GlobalButtonsStyled isPlatformMobile={isPlatformMobile}/>
        <GlobalDatePickerStyled/>
        <GlobalFormsStyled/>
        <GlobalListStyled/>
        <GlobalModalStyled/>
        <GlobalNotificationsStyled/>
        <GlobalOverlaysStyled/>
        <GlobalUtilsStyled/>
    </>
};